/**
 * Returns a date that updates every 3 days starting from 2025-11-10
 * Examples:
 * - 2025-11-10 to 2025-11-12: "2025-11-10"
 * - 2025-11-13 to 2025-11-15: "2025-11-13"
 * - 2025-11-16 to 2025-11-18: "2025-11-16"
 */
export const getUpdatedDate = (): string => {
  const startDate = new Date('2025-11-10');
  const today = new Date();
  
  // Calculate days since start date
  const daysSinceStart = Math.floor((today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
  
  // Round down to nearest multiple of 3
  const daysToAdd = Math.floor(daysSinceStart / 3) * 3;
  
  // Create the updated date
  const updatedDate = new Date(startDate);
  updatedDate.setDate(updatedDate.getDate() + daysToAdd);
  
  return updatedDate.toLocaleDateString('sv-SE');
};
